import Pie3DDataset from './pie3d';
import doughnut3dAnimation from '../animation-rules/doughnut3d-animation';
import { addDep } from '../dependency-manager';

addDep({
  name: 'doughnut3dAnimation',
  type: 'animationRule',
  extension: doughnut3dAnimation
});
class Doughnut3DDataset extends Pie3DDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'doughnut3D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.doughnutradius = '50%';
  }
  _configurePie3DManager () {
    var dataSet = this,
      dataSetConfig = dataSet.config,
      dataSetComponents = dataSet.components,
      pie3DManager = dataSet.getFromEnv('pie3DManager'),
      data = dataSetComponents.data;

    if (pie3DManager) {
      pie3DManager.configure(dataSetConfig.pieSliceDepth, data.length === 1, dataSetConfig.use3DLighting,
        true);
    }
  }
}
export default Doughnut3DDataset;
